import React from 'react'
import type { FormikValues } from 'formik'
import { useField } from 'formik'

import { TtFileInput } from '@23/react'

import type {
  FieldNameMatchingAcceptedType,
  FormikFormControlProps,
} from './index'

const TtFileInputFormik = <FV extends FormikValues>({
  name,
  validate,
  invalid,
  errorText,
  ...props
}: FormikFormControlProps<'tt-file-input'> & {
  name: FieldNameMatchingAcceptedType<FV, HTMLTtFileInputElement['files']>
}) => {
  const [field, meta, helpers] = useField<HTMLTtFileInputElement['files']>({
    name,
    type: 'file',
    validate,
  })

  return (
    <TtFileInput
      {...props}
      name={field.name}
      files={field.value}
      onBlur={field.onBlur}
      onTt-change={(e) => {
        const fileList = e.detail.value ?? undefined
        helpers.setValue(fileList?.length === 0 ? undefined : fileList)
      }}
      invalid={meta.touched && (!!meta.error || invalid)}
      errorText={meta.error ?? errorText}
    />
  )
}

export { TtFileInputFormik }
